import { Button } from '@trmediaab/zebra';
import { Spinner } from '@trmediaab/zebra-icons';

type NextButtonProps = React.ComponentProps<typeof Button> & {
  variant?: 'primary' | 'secondary';
  enabled?: boolean;
  href?: string;
  target?: string;
} & (
    | { label: string; showSpinner?: never }
    | { label?: never; showSpinner: true }
    | { label?: string; showSpinner?: boolean }
  );

const NextButton = ({
  label = 'Gå vidare',
  showSpinner = false,
  variant = 'primary',
  ...props
}: NextButtonProps) => (
  <Button
    bc={variant === 'primary' ? 'checkoutPrimary' : 'checkoutSecondary'}
    width="100%"
    sx={{ whiteSpace: 'nowrap' }}
    target={props.href != null ? '_top' : undefined}
    {...props}
  >
    {showSpinner ? <Spinner size="2em" /> : label}
  </Button>
);

export default NextButton;
